import AUStates from './it-IT/AU-states.json.js';
import CAStates from './it-IT/CA-states.json.js';
import CNStates from './it-IT/CN-states.json.js';
import CompanySize from './it-IT/company-size.json.js';
import CompanyType from './it-IT/company-type.json.js';
import countries from './it-IT/countries.json.js';
import DEStates from './it-IT/DE-states.json.js';
import HKStates from './it-IT/HK-states.json.js';
import INStates from './it-IT/IN-states.json.js';
import industry from './it-IT/industry.json.js';
import interests from './it-IT/interests.json.js';
import jobRole from './it-IT/job-role.json.js';
import levelOfAWSUsage from './it-IT/level-of-aws-usage.json.js';
import projectTimeline from './it-IT/project-timeline.json.js';
import PTStates from './it-IT/PT-states.json.js';
import USStates from './it-IT/US-states.json.js';
import useCase from './it-IT/use-case.json.js';
import languagePreference from './it-IT/language-preference.json.js';
import Navatar from '../it-IT/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
